import { CategoryType } from "@/types/baseTypes";
import { requireDefined } from "@/utils/envs";
import { getDataArrayGeneric } from "./getData";
import { CategoryOverviewPages } from "./getPostGridData";
import type { CardGridTaxonomy } from "./cardGridSource";

interface GetCardGridCatDataProps {
  locale?: string;
  taxonomy: CardGridTaxonomy;
}

export interface CardGridCategory extends CategoryOverviewPages {
  parent: number;
}

export interface CardGridCategories {
  categories: CardGridCategory[];
}

/* jscpd:ignore-start */
export const getCardGridCatData = async ({
  locale,
  taxonomy,
}: GetCardGridCatDataProps): Promise<CardGridCategories> => {
  const defaultLocale = requireDefined(process.env.NEXT_PUBLIC_DEFAULT_LOCALE);

  const fetchedCategories = await getDataArrayGeneric<CategoryType[]>(
    `/${taxonomy}?per_page=100`,
    locale,
    defaultLocale,
  );

  const categories: CardGridCategory[] = fetchedCategories.pageData.map(
    (category) => {
      return {
        slug: category.slug,
        id: category.id,
        name: category.name,
        link: "",
        parent: category.parent,
      };
    },
  );

  return {
    categories,
  };
};
/* jscpd:ignore-end */
